import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType } from '../../../../packages/JsonQuery';
import { selectHasBathhouse, selectHasGarage, selectHasPool, selectHasSecurity } from 'shared/selectors/jsonQuery';

export const selectSuburbanFacilitiesValue = createSelector(
  [selectHasBathhouse, selectHasGarage, selectHasPool, selectHasSecurity],
  (hasBathhouse, hasGarage, hasPool, hasSecurity) => {
    const facilityTypes: EFacilityType[] = [];

    if (hasBathhouse) {
      facilityTypes.push(EFacilityType.Sauna);
    }

    if (hasGarage) {
      facilityTypes.push(EFacilityType.Garage);
    }

    if (hasSecurity) {
      facilityTypes.push(EFacilityType.Security);
    }

    if (hasPool) {
      facilityTypes.push(EFacilityType.Pool);
    }

    return facilityTypes.length > 0 ? facilityTypes : [null];
  },
);
